import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { DriverScheduleFilterModel, DriverScheduleSortModel } from './driver-schedule-filter.model';

export interface ScheduleDateSelection {
  date: string;
  selected: boolean;
}

export interface ScheduleSortChange {
  sortModel: DriverScheduleSortModel[];
  orderedDriverIds: number[];
}

@Injectable()
export class DriverScheduleService extends ParentService {

  private reloadSubject = new Subject<void>();
  public reload$ = this.reloadSubject.asObservable();

  private dateSelectionSubject = new Subject<ScheduleDateSelection>();
  public dateSelection$ = this.dateSelectionSubject.asObservable();

  private scheduleSortChangedSubject = new Subject<ScheduleSortChange>();
  public scheduleSortChanged$ = this.scheduleSortChangedSubject.asObservable();

  private scheduleFilterModelChangedSubject = new Subject<DriverScheduleFilterModel>();
  public scheduleFilterModelChanged$ = this.scheduleFilterModelChangedSubject.asObservable();

  constructor(private http: Http, private router: Router) {
    super();
  }

  public emitReload(): void {
    this.reloadSubject.next();
  }

  public emitDateSelection(value: ScheduleDateSelection): void {
    this.dateSelectionSubject.next(value);
  }

  public emitScheduleSortChanged(value: ScheduleSortChange): void {
    this.scheduleSortChangedSubject.next(value);
  }

  public emitScheduleFilterModelChanged(value: DriverScheduleFilterModel): void {
    this.scheduleFilterModelChangedSubject.next(value);
  }

  /**
   * this get all schedules
   */
  getSchedules(start, end, providerid) {
    return this.http.get(constant.URL_DRIVER_SCHEDULE_LIST + `/${start}/${end}/${providerid}`, this.getHeader())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router))
  }

  /**
   * this save a schedule
   */
  updateSchedule(data) {
    let body = JSON.stringify(data);
    return this.http.put(constant.URL_DRIVER_SCHEDULE, body, this.headerPost())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router))
  }

  /**
   * this paste schedule
   * @param data data to paste
   */
  pasteSchedule(data) {
    let body = JSON.stringify(data);
    return this.http.put(constant.URL_DRIVER_SCHEDULE_PASTE, body, this.headerPost())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router))
  }

  /**
   * this add driver schedule
   * @param data data
   */
  addSchedule(data) {
    let body = JSON.stringify(data);
    return this.http.post(constant.URL_DRIVER_SCHEDULE_ADD, body, this.headerPost())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router))
  }

  /**
   * this reset schedule
   * @param data data to reset
   */
  resetSchedule(data) {
    let body = JSON.stringify(data);
    return this.http.put(constant.URL_DRIVER_SCHEDULE_RESET, body, this.headerPost())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router))
  }

  /**
   * this the schedule history
   */
  getHistorySchedules(date, providerId?: number) {
    return this.http.get(constant.URL_DRIVER_SCHEDULE_HISTORY + `/${date}/${providerId}`, this.getHeader())
    .map(res => res.json())
    .catch(error => this.validate401Error(error, this.router))
  }

  postAmbulatoryAutorouting(date: string) {
    return this.http
      .post(`${constant.URL_AMBULATORY_AUTOROUTING}/${date}`, null, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/driver-schedule.service.ts